import React from 'react'
import { Row, Col, Card, Statistic, Typography } from 'antd'
import { UserOutlined, MedicineBoxOutlined, ClockCircleOutlined, CalendarOutlined } from '@ant-design/icons'

const { Text } = Typography

const StatisticsCards = ({ dashboardSummary }) => {
  return (
    <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Card>
          <Statistic
            title='Admissions'
            value={dashboardSummary.admissions.active}
            suffix={`/ ${dashboardSummary.admissions.total}`}
            valueStyle={{ color: '#1890ff' }}
            prefix={<UserOutlined />}
          />
          <div style={{ marginTop: '8px', fontSize: '12px' }}>
            <Text type='secondary'>{dashboardSummary.admissions.pending} pending admissions</Text>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6}>
        <Card>
          <Statistic
            title='Bed Occupancy'
            value={dashboardSummary.beds.occupancyRate}
            suffix='%'
            valueStyle={{
              color:
                dashboardSummary.beds.occupancyRate > 90
                  ? '#cf1322'
                  : dashboardSummary.beds.occupancyRate > 75
                  ? '#faad14'
                  : '#3f8600'
            }}
            prefix={<MedicineBoxOutlined />}
          />
          <div style={{ marginTop: '8px', fontSize: '12px' }}>
            <Text type='secondary'>
              {dashboardSummary.beds.occupied} occupied, {dashboardSummary.beds.available} available
            </Text>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6}>
        <Card>
          <Statistic
            title='Critical Tasks'
            value={dashboardSummary.tasks.critical}
            valueStyle={{ color: dashboardSummary.tasks.critical > 5 ? '#cf1322' : '#faad14' }}
            prefix={<ClockCircleOutlined />}
          />
          <div style={{ marginTop: '8px', fontSize: '12px' }}>
            <Text type='secondary'>{dashboardSummary.tasks.dueToday} tasks due today</Text>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6}>
        <Card>
          <Statistic
            title='Surgeries Today'
            value={dashboardSummary.surgeries.today}
            valueStyle={{ color: '#1890ff' }}
            prefix={<CalendarOutlined />}
          />
          <div style={{ marginTop: '8px', fontSize: '12px' }}>
            <Text type='secondary'>{dashboardSummary.theatres.active} active theatres</Text>
          </div>
        </Card>
      </Col>
    </Row>
  )
}

export default StatisticsCards
